export default __webpack_public_path__ + "static/media/sticker-N.6f510df5.png";